import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { throwError, Observable } from 'rxjs';
import { ContractActionLog } from '../models/contractActionLog.model';
import { catchError } from 'rxjs/operators';
import { delayedRetryHttp } from '../shared/delayedRetry';
import { UtilityService } from './shared/utility.service';

@Injectable({
    providedIn: 'root'
})
export class ContratActionLogService {

    private baseUrl: string;
    private api: string = "api/ContractActionLog";

    constructor(private httpClient: HttpClient, @Inject('BASE_URL') _baseUrl: string, private _utilityService: UtilityService) {
        this.baseUrl = _baseUrl + this.api;
    }

    private handleErrors(errorResponse: HttpErrorResponse) {
        if (errorResponse.error instanceof ErrorEvent) {
            console.error('ContractActionLog Service Client Side Error: ', errorResponse.error.message);
        } else {
            console.error('ContractActionLog Service Server Side Error: ', errorResponse);
        }

        return throwError("There is a problem with the service. We are notified & working on it. Please try again later.");
    }

    async getContractActionLog(encryptedUser: string, contractSessionId: number): Promise<ContractActionLog | void> {
        const a = await this.httpClient
            .get<ContractActionLog>(`${this.baseUrl}/ContractActionLog_Get/${contractSessionId}`, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser,
                    'Retry-After': '15'
                })
            }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "contractSessionId - " + contractSessionId, encryptedUser, "ContratActionLogService", "getContractActionLog"); });


        return a;
    }

    getContractActionLogOb(encryptedUser: string, contractSessionId: number): Observable<ContractActionLog> {
        return this.httpClient
            .get<ContractActionLog>(`${this.baseUrl}/ContractActionLog_Get/${contractSessionId}`, {
                headers: new HttpHeaders({
                    'Authorization': 'Basic ' + encryptedUser,
                    'Retry-After': '15'
                })
            })
            .pipe(
                catchError(this.handleErrors)
            );
    }

    async updateContractActionLog(encryptedUser: string, actionLog: ContractActionLog): Promise<ContractActionLog | void> {
        const a = await this.httpClient.post<ContractActionLog>(`${this.baseUrl}/ContractActionLog_Create`, actionLog, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': 'Basic ' + encryptedUser
            })
        }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, actionLog, "", encryptedUser, "ContratActionLogService", "updateContractActionLog"); });
        return a;
    }

    async getContractActionLogWaitDT(encryptedUser: string, contractSessionId: number): Promise<Date | void> {
        const a = await this.httpClient
            .get<Date>(`${this.baseUrl}/ContractActionLog_GetWaitDT/${contractSessionId}`, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "contractSessionId - " + contractSessionId, encryptedUser, "ContratActionLogService", "getContractActionLogWaitDT"); });
        return a;
    }
}
